import { ComponentType } from 'react';
import { JSONObject } from '../types/types';
import { useEditableResolve } from '../hooks/useEditableResolve';

export type WithEditableResolveProp = {
  editable?: boolean | string;
  resolveData: JSONObject;
};

export const withEditableResolve = <P extends WithEditableResolveProp>(
  Component: ComponentType<Omit<P, 'editable'> & { editable: boolean }>
) => {
  const WithEditableResolve = (props: P) => {
    const { editable, resolveData, ...rest } = props;
    // Identity for the `editability` debug feature — wrapped components carry
    // name (form items) or item.name (layout panel).
    const { name, item } = props as {
      name?: string;
      item?: { name?: string };
    };
    const { editable: resolvedEditable } = useEditableResolve(
      editable,
      resolveData,
      name ?? item?.name
    );

    return (
      <Component
        {...(rest as Omit<P, 'editable'>)}
        editable={resolvedEditable}
        resolveData={resolveData}
      />
    );
  };

  WithEditableResolve.displayName = `withEditableResolve(${Component.displayName || Component.name || 'Component'})`;
  return WithEditableResolve;
};
